<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :before-close="closeDialog"
    width="50%">
    <el-table :data="receivedSummary"
              stripe
              highlight-current-row
              border
              style="width: 100%">

      <el-table-column prop="status"
                       label="状态"
                       min-width="120">
        <template slot-scope="scope">
          <span v-for="item in options.received_payment_status"
                v-if="scope.row.received_payment_status * 1 === item.value"
          >{{item.label}}</span>
          <span v-if="scope.row.status * 1 === -1">总计</span>
        </template>
      </el-table-column>
      <el-table-column prop="total"
                       label="含税开票汇总"
                       width="190">
        <template slot-scope="scope">
          {{scope.row.total | seperateThousandsToFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column prop="received_amount"
                       label="已回款汇总"
                       width="190">
        <template slot-scope="scope">
          {{scope.row.received_amount | seperateThousandsToFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column prop="unreceived_amount"
                       label="未回款汇总"
                       width="190">
        <template slot-scope="scope">
          {{scope.row.unreceived_amount | seperateThousandsToFixed(2)}}
        </template>
      </el-table-column>

    </el-table>
    <span slot="footer"
          class="dialog-footer" >
        <el-button @click="closeDialog">确认</el-button>
      </span>
  </el-dialog>
</template>

<script>

export default {
  components: {},
  props: {
    visible: Boolean,
    title: String,
    receivedSummary: Array,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
    }),
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/ReceivedSummaryDialog.vue